import * as actionTypes from "./actionTypes";
import { IWorkflowItemStep } from "../../../../common/sharedTypes";
import Api from "../../../../services/Api";
import { ApiResponse } from "apisauce";
import * as documentDownloadService from "../../../../services/documentDownloadService";
import * as urls from "../../../shared/urls";
import { b64toBlob } from "../../../PrintPDF/common/utils";
import {
  CheckersQueueItem,
  ISearchCheckersQueuePagedResponse,
  SearchCheckersQueuePagedRequest,
} from "../business-objects/common";

export const setLoadingWorkflowSteps = (value: boolean) => {
  return {
    type: actionTypes.LOADING_WORKFLOW_STEPS,
    value: value,
  };
};

export const setTotalWorkflowSteps = (value: number) => {
  return {
    type: actionTypes.TOTAL_WORKFLOW_STEPS,
    value: value,
  };
};

export const getCheckerReports = async (
  url: string,
  request: SearchCheckersQueuePagedRequest
): Promise<ApiResponse<ISearchCheckersQueuePagedResponse>> => {
  return await Api.post(url, request);
};

export const searchCheckersPaged = (url: string, request: SearchCheckersQueuePagedRequest) => {
  return async (dispatch) => {
    try {
      dispatch(setLoadingWorkflowSteps(true));
      await getCheckerReports(url, request).then(
        (response: ApiResponse<ISearchCheckersQueuePagedResponse>) => {
          dispatch(setQueueItems(response.data.queueItems));
          dispatch(setTotalWorkflowSteps(response.data.totalResults));
        }
      );
    } catch (ex) {
      console.log(ex);
    } finally {
      dispatch(setLoadingWorkflowSteps(false));
    }
  };
};

export const searchCheckers = (url: string) => {
  return async (dispatch) => {
    try {
      await Api.get(url).then((response: ApiResponse<any>) => {
        dispatch(loadCheckersToStore(response.data));
      });
    } catch (ex) {
      console.log(ex);
    }
  };
};
export const loadCheckersToStore = (workflowItemSteps: IWorkflowItemStep[]) => {
  return {
    type: actionTypes.SEARCH_REPORTS,
    value: workflowItemSteps,
  };
};
export const searchPaperReports = (url: string) => {
  return async (dispatch) => {
    try {
      await Api.get(url).then((response: ApiResponse<any>) => {
        dispatch(setPaperReports(response.data));
      });
    } catch (ex) {
      console.log(ex);
    }
  };
};
export const setPaperReports = (workflowItemStep: IWorkflowItemStep[]) => {
  return {
    type: actionTypes.SEARCH_REPORTS,
    value: workflowItemStep,
  };
};

export const setQueueItems = (checkersQueueItems: CheckersQueueItem[]) => {
  return {
    type: actionTypes.SEARCH_REPORTS_PAGED,
    value: checkersQueueItems,
  };
};

export const openReport = (workflowItemStep: IWorkflowItemStep) => {
  return async (dispatch) => {
    await dispatch(view(workflowItemStep));
    return Promise.resolve(workflowItemStep);
  };
};

export const openReportById = (workflowItemStepId: number, callback?: () => void) => {
  return async (dispatch) => {
    Api.get(urls.GET_WORKFLOW_ITEM_STEP_BY_ID + "?id=" + workflowItemStepId).then(
      (response: ApiResponse<IWorkflowItemStep>) => {
        if (response.ok) {
          dispatch(view(response.data));
          if (callback) {
            callback();
          }
        }
      }
    );
  };
};

export const view = (workflowItemStep: IWorkflowItemStep) => {
  return {
    type: actionTypes.OPEN_REPORT,
    value: workflowItemStep,
  };
};

export const assignAndOpen = (url, stepItemId, assignToId) => {
  return async (dispatch) => {
    try {
      await Api.post(url, {
        workflowStepItemId: stepItemId,
        assignToUserId: assignToId,
      }).then((result: ApiResponse<any>) => {
        dispatch(reduceAssignAndOpen(result.data));
        return Promise.resolve(result.data);
      });
    } catch (ex) {
      console.log(ex);
      return Promise.reject(ex);
    }
  };
};

export const reduceAssignAndOpen = (itemStep: IWorkflowItemStep) => {
  return {
    //type: actionTypes.ASSIGN_AND_OPEN_REPORT,
    type: actionTypes.ASSIGN_AND_OPEN_REPORT,
    value: itemStep,
  };
};

export const unAssign = (url, stepItem) => {
  return async (dispatch) => {
    try {
      await Api.post(url, {
        workflowStepItemId: stepItem.id,
      }).then((result: ApiResponse<any>) => {
        dispatch(reduceUnAssign(result.data));
        return Promise.resolve(result.data);
      });
    } catch (ex) {
      console.log(ex);
      return Promise.reject(ex);
    }
  };
};
export const reduceUnAssign = (itemStep: IWorkflowItemStep) => {
  return {
    type: actionTypes.UNASSIGN,
    value: itemStep,
  };
};

const createApiResponseError = (result: ApiResponse<any>) => {
  const error: any = new Error(
    result.data?.message ||
      result.originalError?.message ||
      "An error occurred while processing the request."
  );
  error.data = result.data;
  error.status = result.status;
  error.problem = result.problem;
  error.originalError = result.originalError;
  return error;
};

export const saveCheckers = (
  itemStep: IWorkflowItemStep,
  data: any,
  complete: boolean,
  assignNext: boolean
) => {
  return async (dispatch) => {
    try {
      const result: ApiResponse<any> = await Api.post(urls.SAVE_CHECKERS, {
        workflowItemStepId: itemStep.id,
        data: JSON.stringify(data),
        complete: complete,
        assignNext: assignNext,
      });

      if (!result.ok) {
        throw createApiResponseError(result);
      }

      if (complete) {
        dispatch(removeFromResults(itemStep));
      }

      dispatch(reduceComplete(result.data));
      return Promise.resolve(result.data);
    } catch (ex) {
      throw ex;
    }
  };
};

export const reduceComplete = (nextItemStep: IWorkflowItemStep) => {
  return {
    type: actionTypes.COMPLETE_CHECKERS,
    value: nextItemStep,
  };
};

export const sendToManagementQueue = (url: string, itemStep: IWorkflowItemStep) => {
  return async (dispatch) => {
    try {
      await Api.post(url, {
        workflowItemStepId: itemStep.id,
      }).then((result: ApiResponse<any>) => {
        dispatch(removeFromResults(itemStep));
        return Promise.resolve(result.data);
      });
    } catch (ex) {
      console.log(ex);
      return Promise.reject(ex);
    }
  };
};
export const removeFromResults = (workflowItemStep: IWorkflowItemStep) => {
  return {
    type: actionTypes.REMOVE_FROM_RESULTS,
    value: workflowItemStep,
  };
};

// export const loadCheckersIntoStore = (checkers: any) => {
//   return {
//     type: actionTypes.LOAD_DATA_ENTRY_INTO_STORE,
//     value: checkers,
//   };
// };

export const loadImage = (documentId: string, forceNewWindow: boolean) => (dispatch) =>
  new Promise<void>(function (resolve, reject) {
    documentDownloadService.getOnBaseImage(null, documentId).then((response: any) => {
      const file = b64toBlob(response.pdf, "application/pdf");
      const fileURL = URL.createObjectURL(file);
      dispatch(reduceLoadImage(fileURL, forceNewWindow));
      resolve();
    });
  });

export const reduceLoadImage = (fileUrl: string, forceNewWindow: boolean) => {
  return {
    type: actionTypes.LOAD_CHECKERS_IMAGE,
    value: { fileUrl, forceNewWindow },
  };
};

export const getFrontSheet = (crashId) => {
  return async (dispatch) => {
    try {
      await documentDownloadService.getFrontSheet(crashId).then((data: any) => {
        if (data) {
          dispatch(reduceFrontSheet(data));
        }
        return Promise.resolve(data);
      });
    } catch (ex) {
      console.log(ex);
      return Promise.reject(ex);
    }
  };
};
export const reduceFrontSheet = (frontSheet: string | Uint8Array) => {
  return {
    type: actionTypes.GET_FRONTSHEET,
    value: frontSheet,
  };
};

export const getForm40 = (crashId: number, isRedacted: boolean) => {
  return async (dispatch) => {
    try {
      await documentDownloadService.form40(crashId, isRedacted).then((data: any) => {
        dispatch(reduceForm40(data));
        return Promise.resolve(data);
      });
    } catch (ex) {
      console.log(ex);
      return Promise.reject(ex);
    }
  };
};
export const reduceForm40 = (image: string | Uint8Array) => {
  return {
    type: actionTypes.GET_FORM_40,
    value: image,
  };
};
